import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../client";

export interface IExamPaperReviewResponse {
  success: boolean;
  message: string;
  data: {
    paper: {
      id: string;
      exam_type: string;
      subject: string;
      title: string;
      description: string;
      difficulty: number;
    };
    sections: Array<{
      section_no: number;
      duration: number;
      question_count: number;
      question_ids: string[];
      questions: Array<{
        id: string;
        passage?: string;
        question: string;
        choices: Array<{
          id: string;
          text: string;
        }>;
        answer_type: "multiple_choice" | "short_answer";
        correct_choice_id: string;
        category_id: string;
        difficulty: number;
        correct_ratio: number;
      }>;
      answers: Array<{
        question_id: string;
        selected_answer: string;
        excluded_choices: string[];
        marked_for_review: boolean;
        is_correct: boolean;
        correct_answer: string;
        question_type: "multiple_choice" | "short_answer";
      }>;
      module_progress: {
        module_no: number;
        status: string;
        started_at: string;
        completed_at: string;
      };
    }>;
    paper_status: {
      status: string;
      module_progress: Array<{
        module_no: number;
        status: string;
        started_at: string;
        completed_at: string;
      }>;
    };
    exam_status: {
      status: string;
      started_at: string;
      completed_at: string;
    };
  };
}

export const getExamPaperReview = async (
  examProgressId: string,
  examPaperId: string
): Promise<IExamPaperReviewResponse["data"]> => {
  const response = await apiGet<IExamPaperReviewResponse["data"]>(
    `/exam_progress/${examProgressId}/exam_papers/${examPaperId}/review`
  );
  return response.data!;
};

export const useQueryGetExamPaperReview = (
  examProgressId: string,
  examPaperId: string,
  enabled = true
) => {
  return useQuery({
    queryKey: ["exam_paper_review", examProgressId, examPaperId],
    queryFn: () => getExamPaperReview(examProgressId, examPaperId),
    enabled: enabled && !!examProgressId && !!examPaperId,
  });
};
